module.exports = __webpack_public_path__ + "static/img/Water-of-the-Sun4.e00814d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/looking-ahead/Water-of-the-Sun4.jpg
// module id = iOzJ
// module chunks = 0